import React, { memo } from 'react';
import { IBlock } from '../../../../store/reducers/editors';
import { Block } from './Block';
import useStyles from '../../../../views/EditorItem/styles';
import { blockDefaultColor } from './blockColor';

export const Columns5TextBlock = memo((props: IBlock) => {
  const cc = useStyles();
  return (
    <Block {...props} className={cc.headerBlock}>
      <svg
        width="156"
        height="24"
        viewBox="0 0 156 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24.8" height="3" rx="1.5" fill={blockDefaultColor} />
        <rect
          y="6.66699"
          width="24.0485"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          y="13.333"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          y="20"
          width="10.5212"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="32.8"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="32.8"
          y="6.66699"
          width="24.0485"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="32.8"
          y="13.333"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="32.8"
          y="20"
          width="10.5212"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="65.6001"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="65.6001"
          y="6.66699"
          width="24.0485"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="65.6001"
          y="13.333"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="65.6001"
          y="20"
          width="10.5212"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="98.3999"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="98.3999"
          y="6.66699"
          width="24.0485"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="98.3999"
          y="13.333"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="98.3999"
          y="20"
          width="10.5212"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="131.2"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="131.2"
          y="6.66699"
          width="24.0485"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="131.2"
          y="13.333"
          width="24.8"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
        <rect
          x="131.2"
          y="20"
          width="10.5212"
          height="3"
          rx="1.5"
          fill={blockDefaultColor}
        />
      </svg>
    </Block>
  );
});
